import React from 'react';
import { __ } from '@wordpress/i18n';
import {
	H2,
	Spacer
} from '../../ui/style';

import { useStateValue } from '../../store/store';
import TextField from '@material-ui/core/TextField';

import {
	NextStepLink,
	PreviousStepLink,
	DefaultStep,
	ProgressBar,
	ImagePreview,
} from '../../components/index'

const BusinessInformation = () => {
	const [{ businessName, businessAddress, businessEmail, businessPhone }, dispatch] = useStateValue();

	const saveSiteTitle = () => {
		const data = new FormData();
		data.append('action', 'astra_sites_set_site_data');
		data.append('param', 'site-title');
		data.append('business-name', businessName);
		data.append('security', starterTemplates.nonce);

		fetch(ajaxurl, {
			method: 'post',
			body: data
		});
	}

	return (
		<DefaultStep
			content={
				<>
					<H2>{__('Your Business Information', 'astra-sites')}</H2>
				</>
			}
			controls={
				<>
					<TextField
						label={__('Name', 'astra-sites')}
						variant="outlined"
						placeholder={__('Sharmila\'s Beauty Salon', 'astra-sites')}
						fullWidth={true}
						value={businessName}
						onChange={(event) => {
							dispatch({
								type: 'set',
								businessName: event.target.value,
							})
						}}
						classes={{ root: 'business-name' }}
					/>
					<Spacer />

					<TextField
						label={__('Address', 'astra-sites')}
						variant="outlined"
						placeholder={__('Sharmila\'s Beauty Salon, some street, nearby landmark, Area, Pune, Maharashtra', 'astra-sites')}
						id="business-name"
						fullWidth={true}
						value={businessAddress}
						onChange={(event) => {
							dispatch({
								type: 'set',
								businessAddress: event.target.value,
							})
						}}
						multiline={true}
						classes={{ root: 'business-address' }}
					/>
					<Spacer />

					<TextField
						label={__('Email', 'astra-sites')}
						variant="outlined"
						placeholder={__('Enter your email address here', 'astra-sites')}
						fullWidth={true}
						value={businessEmail}
						onChange={(event) => {
							dispatch({
								type: 'set',
								businessEmail: event.target.value,
							})
						}}
						classes={{ root: 'business-email' }}
						type="email"
					/>
					<Spacer />

					<TextField
						label={__('Phone', 'astra-sites')}
						variant="outlined"
						placeholder={__('Enter your phone number', 'astra-sites')}
						fullWidth={true}
						value={businessPhone}
						onChange={(event) => {
							dispatch({
								type: 'set',
								businessPhone: event.target.value,
							})
						}}
						classes={{ root: 'business-phone' }}
						type="text"
					/>
				</>
			}
			actions={
				<>
					<PreviousStepLink before>{__('Back', 'astra-sites')}</PreviousStepLink>
					<ProgressBar />
					<NextStepLink ml1 after onClick={saveSiteTitle}>{__('Next', 'astra-sites')}</NextStepLink>
				</>
			}
			preview={
				< ImagePreview fileName='step-4.png' />
			}
		/>
	)
}

export default BusinessInformation;
